import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FormikValues, useFormikContext } from "formik";

import FormStepTitle from "../../form/FormStepTitle";
import DropdownField from "../../../../../common/form/dropdown/DropdownField";
import PatientAdmissionTitleAndInput from "../../form/PatientAdmissionTitleAndInput";

import { H5 } from "../../../styles";
import { useParams } from "react-router-dom";
// import { departments, diseases } from "../../../../../../constants/patient";
import diseaseService from "../../../../../../services/disease";
import { logger } from "../../../../../../utils/logger";
import departmentService from "../../../../../../services/department";

const AdmissionStepOne = () => {
  const { setFieldTouched, values, setFieldValue } =
    useFormikContext<FormikValues>();
  const { id } = useParams();

  const [diseases, setDiseases] = useState([]);
  const [departments, setDepartments] = useState<{
    _id: string;
    name: string;
    expiresIn: number;
    expiresOn: string;
    maxAmount: number;
  }[]>([]);

  const getData = async () => {
    try {
      const { data: diseaseData } = await diseaseService.getAll();
      const { data: departmentData } = await departmentService.getAll();
      const diseasesDropdownData = diseaseData.data;
      const departmentsDropdownData = departmentData.data;

      const isDiseaseExist = Boolean(
        diseasesDropdownData.find(
          (disease: { name: string }) => disease.name === values.diseaseGroup
        )
      );

      const isDepartmentExist = Boolean(
        diseasesDropdownData.find(
          (department: { name: string }) =>
            department.name === values.department
        )
      );

      if (values.diseaseGroup !== "" && isDiseaseExist === false) {
        diseasesDropdownData.push({ _id: 0, name: values.diseaseGroup });
      }
      if (values.department !== "" && isDepartmentExist === false) {
        departmentsDropdownData.push({ _id: 0, name: values.department });
      }

      setDiseases(diseasesDropdownData);
      setDepartments(departmentsDropdownData);
    } catch (err) {
      logger.error(err);
    }
  };

  useEffect(() => {
    getData();
    setFieldTouched("medicalHistory", !!id);
    setFieldTouched("diseaseGroup", !!id);
    setFieldTouched("lastTreatingDrNmae", !!id);
    setFieldTouched("drClinicLocaton", !!id);
    setFieldTouched("department", !!id);
    setFieldTouched("reasonForReferral", !!id);
    setFieldTouched("finalDiagnosis", !!id);
  }, [id, setFieldTouched]);

  const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.value, true);
  };

  const departmentInputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.value, true);
    const department = departments.find(
      (d: { name: string }) => d.name === e.target.value
    );
    if (department && department?._id) {
      setFieldValue("departmentId", department._id, true);
    }
  };

  return (
    <>
      <FormStepTitle title="Medical History" required />
      <PatientAdmissionTitleAndInput
        title="Medical History Biref*"
        name="medicalHistory"
        placeholder="Medical History"
        multiline
      />

      <PatientAdmissionTitleAndInput
        title="Referring doctor*"
        name="lastTreatingDrNmae"
        placeholder="Referring  doctor"
        required
      />

      {/* <PatientAdmissionTitleAndInput
        title="Last Doctor Location"
        name="drClinicLocaton"
        placeholder="Last Doctor Location"
      /> */}
      <Box sx={{ display: "flex", flexWrap: "wrap", margin: "0 -8px 0" }}>
        <Box
          sx={{
            width: "50%",
            padding: "12px 8px 0",
            "@media (max-width: 767px)": {
              width: "100%",
              padding: "0 8px 0",
            },
          }}
        >
          <H5>Department</H5>
          <DropdownField
            name="department"
            label="Department Information*"
            dropDownList={departments.map((d: { name: string }) => ({
              _id: d.name,
              name: d.name,
            }))}
            itemFieldValue="_id"
            itemFieldLabel="name"
            value={values?.department}
            onChange={departmentInputHandler}
          />
        </Box>
        <Box
          sx={{
            width: "50%",
            padding: "12px 8px 0",
            "@media (max-width: 767px)": {
              width: "100%",
              padding: "0 8px 0",
            },
          }}
        >
          <H5>Treatment</H5>
          <DropdownField
            name="diseaseGroup"
            label="Treatment Information*"
            dropDownList={diseases.map((d: { name: string }) => ({
              _id: d.name,
              name: d.name,
            }))}
            itemFieldValue="_id"
            itemFieldLabel="name"
            value={values?.diseaseGroup}
            onChange={inputHandler}
          />
        </Box>
      </Box>
      <PatientAdmissionTitleAndInput
        title="Reason for referral*"
        name="reasonForReferral"
        placeholder="Reason for referral*"
        multiline
      />
      <PatientAdmissionTitleAndInput
        title="Final Diagnosis*"
        name="finalDiagnosis"
        placeholder="Final Diagnosis*"
        multiline
        rows={2}
      />
    </>
  );
};

export default AdmissionStepOne;
